// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__OHm6q","calendarButtons":"ClockData_calendarButtons__3pr63"};